import http from './http'

// 走 CDN 的公开内容请求：URL 带 fk 驱动缓存失效、带 r=cn/os 分区防串号。
// cdnBase 生产指向 cdn.zhso.org，开发可留空走代理/源站。
const cdnBase = process.env.VUE_APP_CDN_BASE || '/'
const cdnGet = (url, params) => http.get(url, { baseURL: cdnBase, params })
const apiBase = process.env.VUE_APP_API_BASE || '/'

function toAbsoluteUrl(path) {
  if (/^https?:\/\//i.test(path)) return path
  if (typeof window === 'undefined') return path
  return new URL(path, window.location.origin).toString()
}

// ============ 站点 / FreshKey ============
export const getSite = () =>  http.get('/api/site')   // 站点信息也走 CDN（过期时间由 CDN 侧控制）
export const getLinkPreview = (params) => cdnGet('/api/site/link-preview', params)
export const getFresh = (type, id = 0) => http.get('/api/fresh', { params: { type, id } })
export const getWorldRssUrl = () => toAbsoluteUrl(`${apiBase.replace(/\/$/, '')}/api/rss`)
export const getTopicRssUrl = (slug) => toAbsoluteUrl(`${apiBase.replace(/\/$/, '')}/api/rss/topic/${slug}`)

// ============ 搜索 ============
export const search = (params) => http.get('/api/search', { params })
// 详情页底部「相关推荐」：按标题检索，走 CDN（按 kw+分区 缓存）
export const searchCdn = (params) => cdnGet('/api/search', params)
// AI 相关性标注：拿到首页搜索结果后，把 id 列表发后端，让大模型逐条判 high/related/unrelated。
// 走源站（动态、AI 调用、不缓存于 CDN）；覆盖默认超时给后端 75s cURL 留余量。
export const annotateSearch = (data) => http.post('/api/search/annotate', data, { timeout: 90000 })

// ============ 认证 ============
export const anonymousLogin = (anon_key, username) =>
  http.post('/api/auth/anonymous', { anon_key, username })
export const sendCode = (email) => http.post('/api/auth/send-code', { email })
export const emailLogin = (email, code, anon_key) =>
  http.post('/api/auth/email-login', { email, code, anon_key })
export const getMe = () => http.get('/api/auth/me')
export const logout = () => http.post('/api/auth/logout')

// ============ 话题 ============
export const getTopics = (params) => cdnGet('/api/topics', params)
export const getTopicTree = (params) => cdnGet('/api/topics/tree', params)
export const getTopic = (slug, params) => cdnGet(`/api/topic/${slug}`, params)
export const getTopicPosts = (id, params) => cdnGet(`/api/topic/${id}/posts`, params)
export const createTopic = (data) => http.post('/api/topic', data)
export const updateTopic = (data) => http.post('/api/topic/update', data)
export const deleteTopic = (id) => http.post('/api/topic/delete', { id })   // 软删整棵子树
export const moveTopic = (data) => http.post('/api/topic/move', data)        // { id, parent_id, sort } 拖拽移动+排序
export const setTopicOverseas = (id) => http.post('/api/topic/overseas', { id })   // owner 一键切仅海外可见(单向不可逆)

// ============ 帖子 / 评论 / 点赞 ============
export const getPosts = (params) => cdnGet('/api/posts', params)
// 帖子更新计数（走 CDN）：t=20s 时间桶(cache key)，since=打开时最新帖 create_time，topic_id 可选(话题子树)
export const getPostsFresh = (params) => cdnGet('/api/posts/fresh', params)
export const getPost = (id, params) => cdnGet(`/api/post/${id}`, params)
export const getPostMine = (id) => http.get(`/api/post/${id}/mine`)   // 作者本人视角(任意审核状态)，走源站
export const createPost = (data) => http.post('/api/post', data)
export const updatePost = (data) => http.post('/api/post/update', data)   // 编辑后重新审核
export const deletePost = (id, reason = '') => http.post('/api/post/delete', { id, reason })   // reason 仅话题主人删他人帖需要
export const setPostOverseas = (id, overseas = 1) => http.post('/api/post/overseas', { id, overseas })   // 海外/国内可见(双向:作者单向0→1,owner/admin双向)
export const pinPost = (id, pinned) => http.post('/api/post/pin', { id, pinned })   // 置顶(仅系统管理员,仅话题列表)
export const getComments = (postId, params) => cdnGet(`/api/post/${postId}/comments`, params)
export const createComment = (data) => http.post('/api/comment', data)
export const updateComment = (data) => http.post('/api/comment/update', data)   // 编辑评论后重新审核
export const deleteComment = (id) => http.post('/api/comment/delete', { id })   // 仅作者删自己的评论
export const setCommentOverseas = (id) => http.post('/api/comment/overseas', { id })   // 作者一键切仅海外可见(单向不可逆)
export const toggleLike = (target_type, target_id) =>
  http.post('/api/like', { target_type, target_id })

// ============ 内容导入（大模型只处理一次：parse 解析润色+审核；commit 落库） ============
export const importParse = (raw) =>
  http.post('/api/import/parse', { raw }, { timeout: 150000 })   // 覆盖默认 30s，覆盖后端 90s cURL
export const importCommit = (data) =>
  http.post('/api/import/commit', data, { timeout: 120000 })

// ============ 图床 ============
export const uploadImage = (file) => {
  const fd = new FormData()
  fd.append('file', file)
  return http.post('https://pic.zhso.org/api/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    baseURL: '',
  })
}

// ============ 个人中心 ============
export const updateProfile = (data) => http.post('/api/user/profile', data)
export const getMyPosts = (params) => http.get('/api/user/posts', { params })
export const getMyComments = (params) => http.get('/api/user/comments', { params })   // 我的评论(含审核/折叠/敏感状态)
export const getManagedPosts = (params) => http.get('/api/user/managed-posts', { params })   // 我作为话题主人可删的他人帖子
export const getMyTopics = () => http.get('/api/user/topics')   // 我拥有的话题树(嵌套)，走源站(token鉴权,不缓存)
export const getPointsLog = (params) => http.get('/api/user/points', { params })

// ============ 站内信 ============
export const getMessages = (params) => http.get('/api/messages', { params })
export const getUnread = () => http.get('/api/messages/unread')
export const readMessage = (id) => http.post('/api/messages/read', { id })

// ============ 用户资料 / 关注 / 私信 ============
// 均为动态/鉴权接口，走源站 http.*（不可用 cdnGet）
export const getUserProfile = (id) => http.get(`/api/u/${id}`)
export const searchUsers = (kw) => http.get('/api/user/search', { params: { kw } })
export const toggleFollow = (userId) => http.post('/api/follow/toggle', { user_id: userId })
export const getFollowingFeed = (params) => http.get('/api/feed/following', { params })
export const sendDm = (toUserId, content, imageUrl = '') => http.post('/api/dm/send', { to_user_id: toUserId, content, image_url: imageUrl })
export const getDmConversations = () => http.get('/api/dm/conversations')
export const getDmMessages = (convId, params) => http.get('/api/dm/messages', { params: { conversation_id: convId, ...params } })
export const readDm = (convId) => http.post('/api/dm/read', { conversation_id: convId })
export const getDmUnread = () => http.get('/api/dm/unread')

// ============ 申诉 ============
export const createAppeal = (data) => http.post('/api/appeal', data)
export const getMyAppeals = (params) => http.get('/api/appeals', { params })

// ============ 子话题审批 ============
export const getPendingSubTopics = () => http.get('/api/subtopics/pending')
export const handleSubTopic = (data) => http.post('/api/subtopic/handle', data)

// ============ 开放 API 密钥 ============
export const getApiKeys = () => http.get('/api/keys')
export const createApiKey = (data) => http.post('/api/key', data)
export const deleteApiKey = (id) => http.post('/api/key/delete', { id })

// ============ 后台 ============
export const adminLogin = (key) => http.post('/admin/login', { key })
export const adminChangeKey = (new_key) => http.post('/admin/change-key', { new_key })
export const adminStats = () => http.get('/admin/stats')
export const adminGetSettings = () => http.get('/admin/settings')
export const adminSetSetting = (key, value) => http.post('/admin/settings', { key, value })
export const adminGetRefreshConfig = () => http.get('/admin/refresh-config')
export const adminSetRefreshConfig = (page_type, interval_ms) =>
  http.post('/admin/refresh-config', { page_type, interval_ms })
export const adminModeration = (params) => http.get('/admin/moderation', { params })
export const adminAppeals = (params) => http.get('/admin/appeals', { params })
export const adminHandleAppeal = (data) => http.post('/admin/appeal/handle', data)
export const adminUsers = (params) => http.get('/admin/users', { params })
export const adminSetUserStatus = (id, status) => http.post('/admin/user/status', { id, status })
export const adminSetPostAudit = (id, audit_status) => http.post('/admin/post/audit', { id, audit_status })

// 话题 / 帖子管理（搜索、删除、切换区域可见性）
export const adminTopics  = (params) => http.get('/admin/topics', { params })
export const adminPosts   = (params) => http.get('/admin/posts',  { params })
export const adminDeleteTopic  = (id) => http.post('/admin/topic/delete', { id })
export const adminMergeTopic   = (data) => http.post('/admin/topic/merge', data)   // { target_id, source_ids:[] } 合并重复话题
export const adminDeletePost   = (id) => http.post('/admin/post/delete',  { id })
export const adminSetTopicRegion = (id, overseas) => http.post('/admin/topic/region', { id, overseas })
export const adminSetPostRegion  = (id, overseas) => http.post('/admin/post/region',  { id, overseas })
export const adminEsLatest = (params) => http.get('/admin/es/latest', { params })
export const adminQueueStatus = () => http.get('/admin/queue/status')

// RSS 自动采集
export const adminFeedSources = () => http.get('/admin/feed/sources')
export const adminSaveFeedSource = (data) => http.post('/admin/feed/source/save', data)
export const adminDeleteFeedSource = (id) => http.post('/admin/feed/source/delete', { id })
export const adminSetFeedSourceStatus = (id, status) => http.post('/admin/feed/source/status', { id, status })
export const adminCollectFeedSource = (id) => http.post('/admin/feed/source/collect', { id })
export const adminFeedItems = (params) => http.get('/admin/feed/items', { params })
export const adminRetryFeedItem = (id) => http.post('/admin/feed/item/retry', { id })

// 评论抓取
export const adminScrapePostComments = (postId) => http.post('/admin/comment/scrape', { post_id: postId })
export const adminSetPostCommentScrape = (id, enabled) => http.post('/admin/post/comment-scrape', { id, enabled })
